import { createSelector } from "@reduxjs/toolkit";
//#region src/redux/build/selectors.ts
var selecBuildState = () => (store) => store.build;
var selectBuild = () => createSelector([selecBuildState()], (buildState) => buildState?.build);
//#endregion
export { selecBuildState, selectBuild };

//# sourceMappingURL=selectors.js.map